import React from 'react'
import { SvgIcon, SvgIconProps } from '@hermes/web-components'

const defaultColor = '#2C3341'

const GenderIcon = ({ color, ...props }: SvgIconProps) => (
  <SvgIcon width="30" height="31" viewBox="0 0 30 31" {...props}>
    <path
      d="M9.68335 28.1287C9.68335 28.5429 10.0191 28.8787 10.4333 28.8787C10.8476 28.8787 11.1833 28.5429 11.1833 28.1287H9.68335ZM9.68335 21.3582V28.1287H11.1833V21.3582H9.68335Z"
      fill={color || defaultColor}
    />
    <path
      d="M19.0972 7.3013C19.0972 7.71552 19.433 8.0513 19.8472 8.0513C20.2614 8.0513 20.5972 7.71552 20.5972 7.3013L19.0972 7.3013ZM19.0972 2.37268L19.0972 7.3013L20.5972 7.3013L20.5972 2.37268L19.0972 2.37268Z"
      fill={color || defaultColor}
    />
    <path
      d="M13.5088 24.9955H7.35707"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      fill="transparent"
    />
    <path
      d="M17.2578 4.62439L19.8472 2.03479L22.4368 4.62439"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M15.1513 9.72624L16.0281 9.10118C18.4935 7.34369 21.8471 7.52689 24.1063 9.54249V9.54249C26.9013 12.036 27.0074 16.3725 24.3378 18.9997L24.1984 19.137C22.1254 21.1771 18.9521 21.5978 16.4191 20.1683V20.1683C15.8792 19.8636 15.3854 19.4834 14.9528 19.0392L14.642 18.7201C12.9419 16.9747 12.4839 14.3665 13.4875 12.1463V12.1463"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
    <path
      d="M14.8487 18.9528L13.9719 19.5779C11.5065 21.3354 8.15292 21.1522 5.89366 19.1366V19.1366C3.09872 16.6431 2.99257 12.3066 5.66216 9.67933L5.80163 9.54207C7.87458 7.50199 11.0479 7.08128 13.5809 8.51075V8.51075C14.1208 8.81549 14.6146 9.19568 15.0472 9.63983L15.358 9.95896C17.0581 11.7043 17.5161 14.3126 16.5125 16.5328V16.5328"
      stroke={color || defaultColor}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="transparent"
    />
  </SvgIcon>
)

export default GenderIcon
